import type { JournalAttribute } from '../types/journal.types'

/** Уникальный ключ поля формы по id атрибута (избегаем склейки при одинаковом attribute_name). */
export const getFormKey = (attr: JournalAttribute): string => String(attr.id)

/** Атрибут хранит выбор из choices (одиночный или множественный). */
export const needsChoices = (attr: JournalAttribute): boolean =>
  ['option', 'choice', 'content_object', 'multi_option', 'multiple_choice'].includes(
    attr.attribute_type,
  )

export const isMultiSelect = (attr: JournalAttribute): boolean =>
  ['multi_option', 'multiple_choice'].includes(attr.attribute_type)
